/**
* Dual Accordion Lists JS
* -----------------------------------------------------------------------------
*
* All the JS for the Dual Accordion Lists component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'dual-accordion-lists',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // created event handling this way for performance, and minimize amount of event handlers used.
      $( function() {
        document.addEventListener(
            'toggleBefore',
            function( evt ) {
              const title = evt.target;
              if ( !title.matches( '.dual-accordion-lists .content-accordion__title' ) ) return;

              const target = title.nextElementSibling;
              if ( title.classList.contains( 'is-open' ) ) {
                $( target ).slideUp();
              } else {
                $( target ).slideDown();
              }
            },
            true, // ← useCapture = true
        );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'dual-accordion-lists', COMPONENT );
} )( app );
